<template>
  <div class="info-layout">
    <img :src="doctor.imageProfileUrl" class="info-layout__avatar" />
    <div class="info-layout__info">
      <p class="button-text">
        {{ (doctor.treatment == 1 ? 'Dra. ' : 'Dr. ') + getFullName }}
      </p>
      <p class="button-text">Credencial Luminé</p>
      <p class="body-text">{{ doctor.lumineCredential }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
export default Vue.extend({
  name: 'MenuUserinfo',

  props: {
    name: {
      type: String,
      required: true
    },
    credential: {
      required: true,
      type: String
    }
  },

  computed: {
    ...mapState('doctor', ['doctor']),
    ...mapGetters('doctor', ['getFullName'])
  }
})
</script>

<style lang="sass" scoped>
@import @/assets/sass/style
.info-layout
    width: 100%
    display: flex
    justify-content: flex-start
    background: $white
    padding: 16px 10px

    &__avatar
        width: 35px
        height: 35px

    &__info
        display: flex
        flex-direction: column
        padding: 0 6px

        > p
            padding-bottom: 6px
</style>
